import { IMinMaxDefault, UserTargetTypes } from 'fitbeat.models';
import React, { FunctionComponent } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import Lightbulb from '../../assets/icons/lightbulb.svg';
import { defaultScale } from '../../utils/scaling';
import Theme from '../../theme';

interface IProps {
    minMaxDefault: IMinMaxDefault;
    target: number,
    targetType: UserTargetTypes
    t: any;
}

export const WeightTargetRangeInformation: FunctionComponent<IProps> = ({ minMaxDefault, target, targetType, t }) => {

    const displayInformation = () => {
        return targetType === UserTargetTypes.Musclemass ? target >= minMaxDefault.max : target <= minMaxDefault.min;
    }

    return (
        displayInformation() && (
        <View style={styles.container}>
            <Lightbulb width={defaultScale(40)} height={defaultScale(40)} color={Theme.GREY_DARK} />
            <View style={styles.rangeContainer}>
                <Text style={[styles.rangeValues, styles.rangeTextStyle]}>
                  {minMaxDefault.limitTarget
                    ? t('doNotRecommendLowerTarget', {range: targetType === UserTargetTypes.Musclemass ? 'higher' : 'lower'})
                    : t('recomendInitialTarget')}
                </Text>
            </View>
        </View>)
    )
};

const styles = StyleSheet.create({
    container: {
        padding: defaultScale(20),
        borderWidth: defaultScale(0.3),
        flexDirection: 'row',
        borderColor: Theme.GREY,
        marginTop: defaultScale(40),
    },
    rangeContainer: {
        marginLeft: defaultScale(5),
        flexShrink: 1,
    },
    rangeTextStyle: {
        ...Theme.textStyle.bodyCopyReg,
        color: Theme.GREY_MEDIUM,
    },
    rangeValues: {
        marginLeft: defaultScale(12),
    },
});
